export default function IngresoSolicitudes() {
  return (
    <section className="px-6 md:px-8 py-8 max-w-5xl mx-auto">
      <div className="section-tag">Plataforma</div>
      <h2 className="section-title">Ingreso de Solicitudes</h2>
      <div className="card p-6 md:p-8">
        <p className="text-sm text-gray-600 leading-relaxed mb-5">
          Para ingresar una solicitud a la Plataforma de Ayuda Dental, debe estar
          activado como usuario con los siguientes datos:{" "}
          <strong className="text-navy-600">SAP, RUT y mail institucional</strong>.
        </p>
        <a
          href="http://ingresosolicitudes.dentistacontralor.cl"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 bg-codelco text-white text-sm font-medium px-5 py-3 rounded-xl hover:bg-codelco-dark transition-colors"
        >
          Ir a la Plataforma de Ayuda Dental →
        </a>
        <p className="text-xs text-gray-400 mt-4">
          Si no ha recibido mail de aprobación, contactar a{" "}
          <a href="mailto:dentistacontralor@gmail.com" className="text-codelco hover:underline">
            dentistacontralor@gmail.com
          </a>
        </p>
      </div>
    </section>
  );
}
